import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(20, 46, 82, 0.2);
  border-radius: 4px;
  padding: 5px 30px;
`;

export const HeaderAvaliableCandidate = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerSetNotes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
`;

export const AtentionAlert = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background-color: ${BaSeTheme.colors.feedbackInterface.atencao95};
`;

export const ContainerButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const ResultBox = styled.div`
  width: 150px;
  height: 28px;
  background-color: #dedede;

  display: flex;
  align-items: center;
  justify-content: center;
`;
